import * as effects from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import * as actions from './actions'
import * as api from './api'
import { NotionParamsType } from './types'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'

function* fetchNotionPage(payload: NotionParamsType): SagaIterator {
  try {
    const { pageId, key } = payload
    const blocks = yield effects.call(api.fetchNotionPage, pageId, key)
    yield effects.put(actions.fetchNotionPageSuccess(blocks))
  } catch (error) {
    console.warn('Cannot fetch notion page', error)
    yield effects.put(actions.fetchNotionPageFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* watchFetchNotionPage(): SagaIterator {
  yield effects.takeEvery(actions.fetchNotionPage.toString(), fetchNotionPage)
}

export default function* watchNotion(): SagaIterator {
  yield effects.all([effects.fork(watchFetchNotionPage)])
}
